const ZERO_DECIMAL_CURRENCIES = ["JPY", "KRW", "VND", "IDR"];

export function getAmountInSubunits(amount, currency) {
  return ZERO_DECIMAL_CURRENCIES.includes(currency)
    ? Math.round(amount)
    : Math.round(amount * 100);
}

// convert subunit to major unit
export function convertSubunitToMajorUnit(amount, currency) {
   return ZERO_DECIMAL_CURRENCIES.includes(currency)
    ? Math.round(amount)
    : Math.round(amount / 100);
}